import React, { useEffect } from 'react'

import { Col, Row, Typography, Button, Table, Tooltip } from 'antd'
import { EyeOutlined } from '@ant-design/icons'

import { useNavigate  } from 'react-router-dom'

import { MiniLoader, Loader } from '../utility/componentUtility'

import doUtility from '../utility/'

import illustrationsStore from '../../store/slice/illustration.slice.js'

const { Title } = Typography


function Illustrations () {

    const navigate =  useNavigate()

	const IllustrationFolders     = illustrationsStore((state) => state.IllustrationFolders)
    const getIllustrationFolders  = illustrationsStore((state) => state.getIllustrationFolders)
    
    useEffect(()=>{
        illustrationsStore.setState({ illustrationFolderId: null, IllustrationInFolders: null })
        if(IllustrationFolders == null){
            getIllustrationFolders()
        }
    }, [ IllustrationFolders ])


    const viewDetails = (record) => {
        if(record.id !== ""){
            illustrationsStore.setState({ illustrationFolderId: record })
            navigate('/dashboard/illustration/details')
        }
    }

    const action = {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Tooltip placement="top" title={'View Details'}>
                <Button type="default" icon={<EyeOutlined />} onClick={ () => viewDetails(record) }>
                </Button>
            </Tooltip>
        )
    }

    return(
        <div className='dashboard'>

            <Row className='main-heading'>
                <Col md={24}>
                    <Title level={2}>Illustrations</Title>
                </Col>
            </Row>
            
            <Col md={24}>
               {( () => {
                    if (IllustrationFolders && IllustrationFolders.length > 0) {
                        if(IllustrationFolders === 'loading'){
                            return (
                                <MiniLoader />
                            )
                        }else{
                            const IllustrationFolders_list = doUtility.RenderTableData(IllustrationFolders)

                            const column = IllustrationFolders_list.column.filter(function(item) {
                                if(item.dataIndex == 'id' ){
                                    return false
                                }else{
                                    return true
                                }
                            });
                                            
                            return (
                                <Table
                                    className='back-white p10' 
                                    style={{ margin: 'auto', borderRadius: '2px'}} 
                                    dataSource={IllustrationFolders_list.datasource} columns={[...column, action]} />
                            )
                        }
                    }
                }) ()}
            </Col>
        </div>
        
    )
}

export default Illustrations;